module.exports = __webpack_public_path__ + "static/img/qmwallet1-life_privileges_bg.b2d517ee.png";